export const categories = [
  { id: 'movie', name: '电影', slug: 'movie', icon: 'ri-film-line', subcategories: ['动作片', '喜剧片', '爱情片', '科幻片', '恐怖片', '动画片', '纪录片', '战争片', '悬疑片'] },
  { id: 'tv', name: '电视剧', slug: 'tv', icon: 'ri-tv-line', subcategories: ['国产剧', '韩剧', '美剧', '日剧', '泰剧', '港剧', '台剧'] },
  { id: 'variety', name: '综艺', slug: 'variety', icon: 'ri-live-line', subcategories: ['真人秀', '脱口秀', '音乐综艺', '竞技综艺', '旅行综艺'] },
  { id: 'anime', name: '动漫', slug: 'anime', icon: 'ri-rocket-line', subcategories: ['国产动漫', '日本动漫', '欧美动漫', '剧场版'] },
  { id: 'documentary', name: '纪录片', slug: 'documentary', icon: 'ri-global-line', subcategories: ['自然', '历史', '人文', '科技', '美食'] },
];

export const movies = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'movie',
    subcategory: '科幻片',
    year: 2026,
    rating: 8.5,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20astronaut%20in%20space%20with%20earth%20in%20background%2C%20dramatic%20lighting%2C%20cinematic%20film%20poster%20design%2C%20warm%20orange%20and%20dark%20blue%20tones%2C%20epic%20scale%2C%20clean%20composition%20with%20title%20space%20at%20bottom&width=400&height=560&seq=movie-cover-01&orientation=portrait',
    description: '人类面临太阳系危机，全球联合政府启动"流浪地球计划"第三阶段。新一代航天员肩负使命，穿越星际，为人类寻找新的家园。',
    tags: ['科幻', '灾难', '冒险', 'IMAX'],
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '148分钟',
    featured: true,
    trending: true,
    isNew: false,
  },
  {
    id: 2,
    title: '长安三万里2',
    category: 'movie',
    subcategory: '动画片',
    year: 2026,
    rating: 8.9,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%2C%20ancient%20Tang%20dynasty%20Changan%20city%20landscape%2C%20traditional%20Chinese%20painting%20style%2C%20elegant%20warriors%20and%20poets%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20lighting%2C%20film%20poster%20design&width=400&height=560&seq=movie-cover-02&orientation=portrait',
    description: '继首部曲大获成功后，续集继续讲述大唐诗人的传奇故事。李白、杜甫等文人墨客在盛世长安演绎荡气回肠的人生篇章。',
    tags: ['动画', '历史', '文学', '国风'],
    director: '追光动画',
    cast: ['杨天翔', '张喆', '唐小喜'],
    duration: '168分钟',
    featured: true,
    trending: true,
    isNew: true,
  },
  {
    id: 3,
    title: '封神第二部',
    category: 'movie',
    subcategory: '动作片',
    year: 2025,
    rating: 8.2,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%2C%20ancient%20Chinese%20warriors%20in%20armor%20with%20magical%20elements%2C%20dramatic%20epic%20battle%20scene%2C%20golden%20and%20crimson%20color%20palette%2C%20cinematic%20movie%20poster%20design&width=400&height=560&seq=movie-cover-03&orientation=portrait',
    description: '封神大战全面爆发，姜子牙率领众神迎战纣王大军。神话史诗巨制，视觉特效全面升级，展现中国神话的磅礴气势。',
    tags: ['神话', '史诗', '动作', '特效'],
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适'],
    duration: '155分钟',
    featured: false,
    trending: true,
    isNew: false,
  },
  {
    id: 4,
    title: '繁花',
    category: 'tv',
    subcategory: '国产剧',
    year: 2024,
    rating: 9.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20TV%20series%20poster%2C%201990s%20Shanghai%20cityscape%20with%20nostalgic%20atmosphere%2C%20elegant%20characters%20in%20retro%20fashion%2C%20warm%20golden%20lighting%2C%20cinematic%20drama%20poster%20design%20with%20Chinese%20aesthetic&width=400&height=560&seq=movie-cover-04&orientation=portrait',
    description: '九十年代的上海，机遇与挑战并存。阿宝在商海中沉浮，与各色人物交织出一幅生动的时代画卷。王家卫导演首部电视剧作品。',
    tags: ['都市', '商战', '年代', '经典'],
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    episodeCount: '30集',
    featured: true,
    trending: true,
    isNew: false,
  },
  {
    id: 5,
    title: '狂飙',
    category: 'tv',
    subcategory: '国产剧',
    year: 2023,
    rating: 9.1,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%2C%20intense%20police%20and%20underworld%20confrontation%2C%20dark%20and%20gritty%20atmosphere%2C%20two%20men%20facing%20each%20other%2C%20dramatic%20lighting%2C%20film%20noir%20style%20poster&width=400&height=560&seq=movie-cover-05&orientation=portrait',
    description: '一部横跨二十年的扫黑除恶史诗。刑警安欣与黑恶势力展开正邪较量，揭示了权力与正义的终极博弈。',
    tags: ['犯罪', '悬疑', '扫黑', '社会'],
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    episodeCount: '39集',
    featured: false,
    trending: true,
    isNew: false,
  },
  {
    id: 6,
    title: '三体',
    category: 'tv',
    subcategory: '国产剧',
    year: 2024,
    rating: 8.7,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20mysterious%20cosmic%20scene%20with%20three%20suns%2C%20futuristic%20technology%2C%20dark%20and%20mysterious%20atmosphere%2C%20scientific%20elements%2C%20cinematic%20poster%20design%20with%20deep%20space%20background&width=400&height=560&seq=movie-cover-06&orientation=portrait',
    description: '根据刘慈欣同名科幻巨著改编。纳米科学家汪淼卷入一场跨越星际的文明博弈，人类的命运悬于一线。',
    tags: ['科幻', '悬疑', '文学改编', '硬科幻'],
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    episodeCount: '30集',
    featured: true,
    trending: false,
    isNew: false,
  },
  {
    id: 7,
    title: '歌手2025',
    category: 'variety',
    subcategory: '音乐综艺',
    year: 2025,
    rating: 8.3,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20music%20variety%20show%20poster%2C%20singer%20on%20stage%20with%20dramatic%20spotlight%2C%20concert%20atmosphere%2C%20colorful%20stage%20lighting%2C%20modern%20entertainment%20show%20poster%20design%2C%20vibrant%20and%20energetic&width=400&height=560&seq=movie-cover-07&orientation=portrait',
    description: '华语乐坛顶级歌手同台竞技，用声音征服观众。全新赛制升级，国际巨星加盟，打造年度最强音乐盛宴。',
    tags: ['音乐', '竞技', '真人秀', '华语乐坛'],
    director: '洪涛',
    cast: ['那英', '汪峰', '周深', '华晨宇'],
    episodeCount: '12期',
    featured: false,
    trending: true,
    isNew: true,
  },
  {
    id: 8,
    title: '海贼王',
    category: 'anime',
    subcategory: '日本动漫',
    year: 1999,
    rating: 9.5,
    coverImage: 'https://readdy.ai/api/search-image?query=One%20Piece%20anime%20poster%20style%2C%20pirate%20crew%20on%20a%20ship%20with%20ocean%20background%2C%20adventure%20and%20friendship%20theme%2C%20colorful%20anime%20art%20style%2C%20dynamic%20composition%2C%20warm%20and%20vibrant%20colors&width=400&height=560&seq=movie-cover-08&orientation=portrait',
    description: '少年路飞立志成为海贼王，与伙伴们踏上伟大航路的冒险旅程。热血、友情、梦想，跨越二十余年的经典传奇。',
    tags: ['热血', '冒险', '友情', '经典'],
    director: '尾田荣一郎',
    cast: ['田中真弓', '中井和哉', '冈村明美'],
    episodeCount: '1100+集',
    featured: true,
    trending: false,
    isNew: false,
  },
  {
    id: 9,
    title: '舌尖上的中国5',
    category: 'documentary',
    subcategory: '美食',
    year: 2025,
    rating: 9.0,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%2C%20traditional%20Chinese%20cuisine%20close-up%20photography%2C%20steaming%20hot%20dishes%20with%20beautiful%20presentation%2C%20warm%20kitchen%20atmosphere%2C%20artistic%20food%20photography%2C%20rich%20colors%20and%20textures&width=400&height=560&seq=movie-cover-09&orientation=portrait',
    description: '探寻中国各地的美食文化，从街头小吃到国宴大餐，讲述食物背后的人间烟火与动人故事。',
    tags: ['美食', '人文', '纪录片', '中国文化'],
    director: '陈晓卿',
    cast: ['李立宏'],
    episodeCount: '8集',
    featured: false,
    trending: false,
    isNew: true,
  },
  {
    id: 10,
    title: '庆余年2',
    category: 'tv',
    subcategory: '国产剧',
    year: 2024,
    rating: 8.6,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20ancient%20Chinese%20palace%20with%20mysterious%20atmosphere%2C%20handsome%20male%20lead%20in%20traditional%20costume%2C%20dramatic%20lighting%2C%20cinematic%20TV%20series%20poster%20with%20Chinese%20aesthetic&width=400&height=560&seq=movie-cover-10&orientation=portrait',
    description: '范闲继续在庆国的权谋斗争中周旋，揭开更多身世之谜。权谋、爱情、友情交织，续写传奇。',
    tags: ['古装', '权谋', '爱情', '小说改编'],
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    episodeCount: '36集',
    featured: false,
    trending: true,
    isNew: false,
  },
  {
    id: 11,
    title: '孤注一掷',
    category: 'movie',
    subcategory: '悬疑片',
    year: 2023,
    rating: 8.1,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20dark%20mysterious%20atmosphere%2C%20person%20trapped%20in%20danger%2C%20intense%20suspense%20mood%2C%20neon%20lights%20in%20darkness%2C%20cinematic%20thriller%20poster%20design&width=400&height=560&seq=movie-cover-11&orientation=portrait',
    description: '一部揭露境外网络诈骗的惊悚犯罪片。程序员和模特被高薪诱惑，陷入境外诈骗工厂的深渊。',
    tags: ['犯罪', '悬疑', '社会', '警示'],
    director: '申奥',
    cast: ['张艺兴', '金晨', '王传君'],
    duration: '130分钟',
    featured: false,
    trending: false,
    isNew: false,
  },
  {
    id: 12,
    title: '你好星期六',
    category: 'variety',
    subcategory: '真人秀',
    year: 2024,
    rating: 7.8,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20fun%20and%20colorful%20entertainment%20stage%2C%20hosts%20and%20guests%20having%20fun%2C%20bright%20studio%20lighting%2C%20cheerful%20atmosphere%2C%20modern%20TV%20show%20poster%20design&width=400&height=560&seq=movie-cover-12&orientation=portrait',
    description: '何炅领衔主持的王牌综艺节目，每期邀请当红明星参与趣味游戏和互动挑战，带来无限欢乐。',
    tags: ['综艺', '游戏', '明星', '娱乐'],
    director: '湖南卫视',
    cast: ['何炅', '吴泽林', '李雪琴'],
    episodeCount: '52期',
    featured: false,
    trending: false,
    isNew: false,
  },
];

export const bannerSlides = [
  {
    id: 1,
    title: '流浪地球3',
    subtitle: '跨越星际 寻找新家园',
    description: '2026年度科幻巨制，中国科幻电影新标杆',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20banner%20background%2C%20astronaut%20floating%20in%20deep%20space%20with%20glowing%20nebula%2C%20dramatic%20epic%20scale%2C%20warm%20orange%20and%20deep%20blue%20cosmic%20colors%2C%20cinematic%20lighting%2C%20clean%20center%20composition%20with%20dark%20vignette%20edges&width=1920&height=700&seq=banner-01&orientation=landscape',
    link: '/article/1',
    badge: '热播中',
  },
  {
    id: 2,
    title: '长安三万里2',
    subtitle: '大唐诗篇 再续传奇',
    description: '追光动画巨献，国风美学巅峰之作',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20landscape%20banner%2C%20traditional%20Chinese%20architecture%20with%20golden%20sunset%2C%20poetic%20atmosphere%20with%20cherry%20blossoms%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20wide%20composition%2C%20dark%20edges%20for%20text%20overlay&width=1920&height=700&seq=banner-02&orientation=landscape',
    link: '/article/2',
    badge: '新上映',
  },
  {
    id: 3,
    title: '三体',
    subtitle: '宇宙奥秘 文明博弈',
    description: '刘慈欣科幻巨著改编，年度现象级剧集',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20space%20scene%20banner%2C%20distant%20galaxy%20with%20three%20stars%2C%20deep%20space%20with%20subtle%20nebula%20colors%2C%20scientific%20and%20mysterious%20atmosphere%2C%20dark%20cosmic%20background%20with%20warm%20accents%2C%20cinematic%20wide%20composition&width=1920&height=700&seq=banner-03&orientation=landscape',
    link: '/article/6',
    badge: '口碑爆款',
  },
];

export const quickLinks = [
  { name: '最新电影', icon: 'ri-movie-2-line', slug: 'movie', gradient: 'from-rose-500/20 to-orange-500/20' },
  { name: '热门剧集', icon: 'ri-tv-2-line', slug: 'tv', gradient: 'from-amber-500/20 to-yellow-500/20' },
  { name: '综艺节目', icon: 'ri-emotion-laugh-line', slug: 'variety', gradient: 'from-emerald-500/20 to-teal-500/20' },
  { name: '动漫番剧', icon: 'ri-rocket-2-line', slug: 'anime', gradient: 'from-violet-500/20 to-pink-500/20' },
  { name: '纪录片', icon: 'ri-earth-line', slug: 'documentary', gradient: 'from-cyan-500/20 to-blue-500/20' },
];

export const siteInfo = {
  name: '91精品影视',
  description: '91精品影视免费在线观看平台，提供高清电影、电视剧、综艺、动漫在线观看，内容全面、更新迅速、播放流畅不卡顿。随时随地免费看片，尽享高清影视盛宴。',
  keywords: ['91精品影视', '在线看片', '高清影视', '免费电影', '电视剧在线观看'],
  email: 'contact@91jpys.com',
  phone: '400-888-9999',
  address: '北京市朝阳区光华路9号',
  icp: '京ICP备2024XXXXXXXX号',
  year: 2026,
};

export const aboutContent = {
  intro: '91精品影视成立于2018年，是国内领先的免费影视内容信息聚合平台。我们致力于为广大影视爱好者提供最新、最全、最优质的影视内容资讯和观看指南。经过多年的发展，91精品影视已积累了数千万忠实用户，成为国内影视爱好者首选的在线影视内容发现平台。',
  mission: '我们的使命是让每一个人都能轻松发现和享受优质的影视内容。无论是热门大片、经典剧集、精彩综艺还是高分动漫，91精品影视都能为你提供一站式的内容发现体验。',
  values: [
    { title: '内容丰富', description: '涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，满足不同用户的观影需求。' },
    { title: '更新迅速', description: '与各大平台同步更新，确保用户第一时间获取最新影视资讯。' },
    { title: '体验至上', description: '简洁清晰的界面设计，流畅的浏览体验，让找片变得更加轻松愉快。' },
    { title: '用户为本', description: '倾听用户声音，持续优化产品，打造最懂用户的影视平台。' },
  ],
  stats: [
    { number: '5000万+', label: '注册用户' },
    { number: '10万+', label: '影视资源' },
    { number: '99.9%', label: '服务可用率' },
    { number: '4.8/5', label: '用户评分' },
  ],
};